module.exports = __webpack_public_path__ + "img/cisco.5cb5bf90.png";